const automaticReports = require('./automaticReports')
const jsPDF = require('jspdf')
require('jspdf-autotable')
const { getStyle } = require('./reportStyle')
const { headerFromUser } = require('./util/pdfDocument')
const { getUserPartner } = require('fleetmap-partners')
const {
  convertToLocaleString, getTranslations, convertMS,
  getLanguage
} = require('./util/utils')
const { devicesToProcess } = require('./util/device')
const { isInside } = require('./util/timetable')
const { getDigitalPortValue } = require('./location-report')
const { maxParallelRequests } = require('./automaticReports')
const { getNearestPOI } = require('./util/geofence')

const fileName = 'EventReport'

async function createEventsReport (from, to, userData, traccar) {
  console.log('Create EventsReport')
  const reportData = []

  if (userData.byGroup) {
    console.log('ByGroup')
    for (const g of userData.groups) {
      const devices = userData.devices.filter(d => d.groupId === g.id)
      console.log(g.name + ' devices:' + devices.length)
      if (devices.length > 0) {
        const groupData = {
          devices: [],
          group: g,
          xpert: devices.filter(d => d.attributes.xpert).length > 0
        }

        const data = await getReportData(from, to, devices, userData.eventTypes, traccar)

        devices.sort((a, b) => (a.name > b.name) ? 1 : -1)

        if (data.length > 0) {
          groupData.devices = await processDevices(from, to, devices, data, traccar, userData)
          reportData.push(groupData)
        }
      }
    }
  }

  const devices = devicesToProcess(userData)

  const data = await getReportData(from, to, devices, userData.eventTypes || [], traccar)

  if (data.length > 0) {
    reportData.push({
      devices: await processDevices(from, to, devices, data, traccar, userData),
      xpert: devices.filter(d => d.attributes.xpert).length > 0
    })
  }

  return reportData
}

async function getReportData (from, to, devices, types, traccar) {
  let data = []
  const arrayOfArrays = automaticReports.sliceArray(devices)
  const traccarTypes = new Set(types.map(t => t.startsWith('alarm') ? 'alarm' : t))
  await Promise.all(arrayOfArrays.map(async a => {
    const response = await traccar.reports.reportsEventsGet(from, to, a.map(d => d.id), null, traccarTypes)
    data = data.concat(
      response.data.filter(
        e => types.find(t => t === e.type) || types.find(t => t.replace('alarm_', '') === e.attributes.alarm)
      ))
  }))
  console.log('Alerts:' + data.length)
  return data
}

async function processDevices (from, to, devices, data, traccar, userData) {
  const devicesResult = []
  let i = 0
  for (let j = 0; j < devices.length; j += maxParallelRequests) {
    await Promise.all(devices.slice(j, j + maxParallelRequests).map(async d => {
      const deviceAlerts = data.filter(t => t.deviceId === d.id)
      // events can arrive at bd very late, so we search with a 24 hours delay
      const dayBefore = new Date(new Date(from).setDate(from.getDate() - 1))
      const response = await traccar.reports.reportsRouteGet(dayBefore, to, [d.id])
      const positions = response.data

      for (const a of deviceAlerts) {
        a.position = positions.find(p => p.id === a.positionId)

        if (a.type === 'alarm' && a.position) {
          for (const p of positions.filter(p => p.fixTime >= a.position.fixTime)) {
            if (p.attributes.alarm !== a.position.attributes.alarm) { break }
            a.endPosition = p
          }
        }

        if (!a.geofenceId && a.position) {
          const poi = getNearestPOI(a.position, userData.geofences)
          a.geofenceId = poi && poi.p.id
        }
        if (a.geofenceId) {
          const geofence = userData.geofences.find(g => g.id === a.geofenceId)
          if (geofence) {
            if (a.type === 'deviceOverspeed') {
              a.geofenceName = geofence.name + ' (' + Math.round(a.attributes.speedLimit * 1.85200) + ' Km/h)'
            } else {
              a.geofenceName = geofence.name
            }
          }
        }

        if (a.position && a.position.attributes.driverUniqueId) {
          const driver = userData.drivers.find(d => d.uniqueId === a.position.attributes.driverUniqueId)
          a.driver = driver && driver.name
        }
      }

      const alerts = deviceAlerts.filter(a => userData.allWeek || !userData.weekDays || (!a.position || isInside(a.position.fixTime, a.position.fixTime, userData)))
        .filter(a => a.position).sort((a, b) => a.position.fixTime.localeCompare(b.position.fixTime))
      console.log('LOADING_MESSAGE:' + d.name)
      console.log(`PROGRESS_PERC:${++i / devices.length * 100}`)

      if (alerts.length > 0) {
        devicesResult.push({
          device: d,
          from,
          to,
          alerts
        })
      }
    }))
  }

  return devicesResult
}

async function exportSpeedingReportToPDF (userData, reportData) {
  console.log('Export to PDF')
  const lang = getLanguage(userData)
  const translations = getTranslations(userData)
  const timezone = userData.user.attributes.timezone

  const headers = [
    translations.report.eventType,
    translations.report.start,
    translations.report.end,
    translations.report.address,
    translations.report.duration,
    translations.report.info
  ]
  if (reportData.devices) {
    let first = true
    // eslint-disable-next-line new-cap
    const doc = new jsPDF.jsPDF('l')
    await headerFromUser(doc, translations.report.titleEventsReport, userData.user)

    reportData.devices.forEach(d => {
      const data = []
      const name = deviceName(d.device)
      const group = deviceGroupName(translations, userData.groups, d.device)

      let space = 0
      if (!first) {
        doc.addPage()
      } else {
        first = false
        space = 10
      }
      doc.setFontSize(13)
      doc.text(name, 20, space + 20)
      doc.setFontSize(11)
      doc.text(group, 200, space + 20)
      doc.text(convertToLocaleString(d.from, lang, timezone) + ' - ' + convertToLocaleString(d.to, lang, timezone), 20, space + 25)

      const headerEventTypes = []
      userData.eventTypes.forEach(e => {
        const data = e.startsWith('alarm') ? { type: 'alarm', attributes: { alarm: e.slice(6) } } : { type: e }
        const value = e.startsWith('alarm') ? d.alerts.filter(a => a.attributes.alarm === data.attributes.alarm).length : d.alerts.filter(a => a.type === e).length
        if (value > 0) {
          headerEventTypes.push([getEventType(data, translations, d.device), value])
        }
      })

      doc.autoTable({
        head: ['', '', '', '', ''],
        body: [
          headerEventTypes.slice(0, 6).map(a => a[0]),
          headerEventTypes.slice(0, 6).map(a => a[1]),
          headerEventTypes.slice(7).map(a => a[0]),
          headerEventTypes.slice(7).map(a => a[1])
        ],
        startY: space + 30,
        showHead: false,
        bodyStyles: { fillColor: [256, 256, 256], textColor: [30, 30, 30], halign: 'center', valign: 'middle' },
        alternateRowStyles: { fillColor: [256, 256, 256], valign: 'bottom' }
      })
      d.alerts.forEach(a => {
        const temp = [
          getEventType(a, translations, d.device, userData),
          getAlertDate(userData.user, a.position),
          getAlertDate(userData.user, a.endPosition),
          a.geofenceName || (a.position ? a.position.address : ''),
          a.position && a.endPosition ? convertMS(new Date(a.endPosition.fixTime).getTime() - new Date(a.position.fixTime).getTime()) : '',
          getAlertInfo(userData.drivers, a, d.device, translations)
        ]
        data.push(temp)
      })

      const footValues = [
        'Total:' + d.alerts.length,
        '', '', ''
      ]

      const style = getStyle(getUserPartner(userData.user))
      doc.autoTable({
        head: [headers],
        body: data,
        foot: [footValues],
        showFoot: 'lastPage',
        headStyles: {
          fillColor: style.pdfHeaderColor,
          textColor: style.pdfHeaderTextColor,
          fontSize: 10
        },
        bodyStyles: {
          fillColor: style.pdfBodyColor,
          textColor: style.pdfBodyTextColor,
          fontSize: 8
        },
        footStyles: {
          fillColor: style.pdfFooterColor,
          textColor: style.pdfFooterTextColor,
          fontSize: 9
        },
        startY: space + 65
      })
    })
    return doc
  }
}

function getEventType (a, translations, device, userData) {
  if (a.type === 'alarm') {
    let sensor
    if (a.attributes.alarm === 'sensor') { sensor = device.attributes.sensor1 }
    return sensor || translations.report['event_' + a.attributes.alarm] || a.attributes.alarm
  } else {
    const result = translations.report['event_' + a.type] || a.type
    try {
      if (userData &&
          userData.maintenances &&
          a.type === 'maintenance') {
        const maintenance = userData.maintenances.find(m => m.id === a.maintenanceId)
        if (maintenance) { return `${result} ${maintenance.name}` }
      }
    } catch (e) {
      console.error(e)
    }
    return result
  }
}

function exportSpeedingReportToExcel (userData, reportData) {
  console.log('exportSpeedingReportToExcel')

  const translations = getTranslations(userData)

  const settings = {
    sheetName: translations.report.titleEventsReport, // The name of the sheet
    fileName // The name of the spreadsheet
  }
  const headers = [
    { label: translations.report.vehicle, value: 'name' },
    { label: translations.report.eventType, value: 'eventType' },
    { label: translations.report.start, value: 'fixTime' },
    { label: translations.report.end, value: 'endFixTime' },
    { label: translations.report.address, value: 'address' },
    { label: translations.report.duration, value: 'duration' },
    { label: translations.report.zone, value: 'geofenceName' },
    { label: translations.report.driver, value: 'driver' },
    { label: translations.report.info, value: 'info' },
    { label: '', value: 'alarm' },
    { label: 'Latitude', value: 'latitude' },
    { label: 'Longitude', value: 'longitude' }
  ]
  let data = []
  if (reportData.devices) {
    reportData.devices.forEach(d => {
      data = data.concat(d.alerts.map(a => {
        return {
          name: d.device.name,
          eventType: getEventType(a, translations, d.device),
          fixTime: getAlertDate(userData.user, a.position),
          endFixTime: getAlertDate(userData.user, a.endPosition),
          address: a.position && a.position.address,
          duration: a.position && a.endPosition ? convertMS(new Date(a.endPosition.fixTime).getTime() - new Date(a.position.fixTime).getTime()) : '',
          geofenceName: a.geofenceName,
          info: getAlertInfo(userData.drivers, a, d.device, translations),
          driver: a.driver,
          latitude: a.position && a.position.latitude,
          longitude: a.position && a.position.longitude,
          alarm: a.attributes.notifications ? translations.report.alarm : ''
        }
      }))
    })
    return {
      headers,
      data,
      settings
    }
  }
}

function deviceGroupName (translation, groups, device) {
  const group = groups.find(g => device.groupId === g.id)
  if (group) {
    return translation.report.group + ': ' + group.name
  }
  return ''
}

function deviceName (device) {
  return device.name + (device.attributes.license_plate ? ', ' + device.attributes.license_plate : '') + (device.model ? ', ' + device.model : '')
}

function getAlertInfo (drivers, alert, device, translations) {
  if (alert.type === 'alarm' && alert.attributes.alarm === 'sensor') {
    return device ? device.attributes.sensor1on : ''
  }
  if (alert.type === 'alarm' && alert.position) {
    return getDigitalPortValue(alert.position, 1, translations, device.attributes)
  }
  if (alert.type === 'deviceOverspeed') {
    return Math.round(alert.attributes.speed * 1.85200) + ' Km/h'
  }
  if (alert.type === 'driverChanged') {
    const driver = drivers.find(d => d.uniqueId === alert.attributes.driverUniqueId)
    return driver ? driver.name : alert.attributes.driverUniqueId
  }
  return ''
}

function getAlertDate (user, position) {
  if (position) {
    return convertToLocaleString(position.fixTime, user.attributes.lang, user.attributes.timezone)
  }
}

exports.createEventsReport = createEventsReport
exports.exportSpeedingReportToPDF = exportSpeedingReportToPDF
exports.exportSpeedingReportToExcel = exportSpeedingReportToExcel
exports.create = createEventsReport
exports.exportToPDF = exportSpeedingReportToPDF
exports.exportToExcel = exportSpeedingReportToExcel
